<div class="setting">
    <label class="label">{{ label }}</label>

    <div class="content">
        <ng-content></ng-content>
    </div>
</div>
